import { Extension } from '@tiptap/core'

// PROVENANCE ON INSERTED CONTENT (CMR-2026-10-21-392, feature 287 phase 3)
//
// A server-resolved quick phrase is spliced into a chart as ordinary paragraphs, which made it
// indistinguishable from prose the provider typed themselves. Only smart_block and field_token carried any
// provenance. That gap is why the AI scribe cannot tell boilerplate it may reconcile from the provider's own
// wording it must preserve.
//
// This is declared in the schema rather than left as a stray attribute because TipTap drops attributes it does
// not know about: an undeclared marker would survive the server render and then be lost on the first autosave.
export const InsertedFrom = Extension.create({
  name: 'inserted_from',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph', 'heading', 'bulletList', 'orderedList', 'listItem'],
        attributes: {
          inserted_from: {
            default: null,
            parseHTML: (element) => element.getAttribute('data-inserted-from'),
            renderHTML: (attributes) => {
              if (!attributes.inserted_from) {
                return {}
              }
              return { 'data-inserted-from': attributes.inserted_from }
            },
          },
        },
      },
    ]
  },
})
